import { useEffect } from "react";
import "./FeatureCard.scss";


type FeatureCardProps = {
  title: string;
  image: string;
  description: string;
};

const FeatureCard = (props: FeatureCardProps) => {

    useEffect(() => {

    }, []);

  return (
    <div
      className="featureCard"
      style={{ "--gradX": "80%", "--gradY": "70%" } as React.CSSProperties & Record<string, string>}
      onMouseMove={(e) => {
        const rect = (e.target as HTMLDivElement).getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        (e.target as HTMLDivElement).style.setProperty("--gradX", `${x}%`);
        (e.target as HTMLDivElement).style.setProperty("--gradY", `${y}%`);
      }}
    >
      <h2>{props.title}</h2>
      <img src={props.image} alt="" />
      <p>{props.description}</p>
    </div>
  );
}

export default FeatureCard;